import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/contexts/ThemeProvider";
import { AuthProvider } from "@/contexts/AuthProvider";
import { FavouritesProvider } from "@/contexts/FavouritesProvider";
import Layout from "@/components/Layout";

import GMHHome from "@/pages/GMHHome";
import UnifiedSearch from "@/pages/UnifiedSearch";
import Bookings from "@/pages/Bookings";
import Favourites from "@/pages/Favourites";
import SignIn from "@/pages/SignIn";
import NotFound from "@/pages/NotFound";

import CastlewoodHome from "@/pages/castlewood/CastlewoodHome";
import CastlewoodSearch from "@/pages/castlewood/CastlewoodSearch";
import CastlewoodProperty from "@/pages/castlewood/CastlewoodProperty";
import CastlewoodBooking from "@/pages/castlewood/CastlewoodBooking";

import VelaHome from "@/pages/vela/VelaHome";
import VelaSearch from "@/pages/vela/VelaSearch";
import VelaProperty from "@/pages/vela/VelaProperty";
import VelaBooking from "@/pages/vela/VelaBooking";

import BrionjHome from "@/pages/brionj/BrionjHome";
import BrionjCollection from "@/pages/brionj/BrionjCollection";
import BrionjResidence from "@/pages/brionj/BrionjResidence";
import BrionjEnquiry from "@/pages/brionj/BrionjEnquiry";

import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <FavouritesProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<GMHHome />} />
                <Route path="/search" element={<UnifiedSearch />} />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/favourites" element={<Favourites />} />
                <Route path="/auth/sign-in" element={<SignIn />} />

                <Route path="/castlewood" element={<CastlewoodHome />} />
                <Route path="/castlewood/search" element={<CastlewoodSearch />} />
                <Route path="/castlewood/p/:id" element={<CastlewoodProperty />} />
                <Route path="/castlewood/book/:id" element={<CastlewoodBooking />} />

                <Route path="/vela" element={<VelaHome />} />
                <Route path="/vela/search" element={<VelaSearch />} />
                <Route path="/vela/p/:id" element={<VelaProperty />} />
                <Route path="/vela/book/:id" element={<VelaBooking />} />

                <Route path="/brionj" element={<BrionjHome />} />
                <Route path="/brionj/collection" element={<BrionjCollection />} />
                <Route path="/brionj/r/:id" element={<BrionjResidence />} />
                <Route path="/brionj/enquire/:id" element={<BrionjEnquiry />} />

                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-center" />
        </FavouritesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
